module.exports = __webpack_public_path__ + "static/media/tyv.1381c726.m4a";